<script setup lang="ts">
defineProps<{
  contentTypeOptions: CheckboxOption[]
  selectedContentTypes: string[]
  toggleContentType: (type: string, checked: boolean) => void
}>()
</script>

<template>
  <div class="flex flex-col">
    <FormCheckbox
      v-for="opt in contentTypeOptions"
      :id="opt.value"
      :key="opt.value"
      :label="opt.label"
      :model-value="selectedContentTypes.includes(opt.value)"
      name="contentType"
      :disabled="opt.disabled"
      @update:model-value="(checked) => toggleContentType(opt.value, checked)"
    />
  </div>
</template>
